<div class="p-autocomplete-float-group interface-control__custom-input-autocomplete__container">
  <bfx-autoComplete
    #inputField
    [(ngModel)]="data.item"
    [label]="data.label | capitalize:true"
    [suggestions]="data.filteredItems"
    (completeMethod)="autocompleteSearch($event)"
    [disabled]="data.disabled || locked"
    (onFocus)="onFocus($event)"
    (onBlur)="onBlur($event)"
    (onSelect)="onSelect($event)"
    (ngModelChange)="onLowLevelModelChanged($event, data)"
    dataKey="dataItem"
    [field]="data.autocompleteField"
    [selectedField]="'label'"
    [autoHighlight]="true"
    [skipSorting]="true"
    delay="4"
    [state]="data.state"
    [dropdown]="true"
    [style]="{'width':'100%'}"
    [minLength]="1"
    [size]="'sm'"
    [appendTo]="'body'"
    [allowEmptySelection]="input_allowEmpty"
    [emptyIsInactive]="true"
    [settingsCorrection]="true"
    class="interface-control__custom-input-autocomplete__autocomplete"
    [dropdownMenuClass]="dropdownMenuClass"
  >
    <ng-template let-dataItem pTemplate="item">
      <div
        class="ui-helper-clearfix"
        [ngClass]="{'bfx-autocomplete_dropdown-list_field': !dataItem.lastFavorite,
														'bfx-autocomplete_dropdown-list_last-favorite': dataItem.lastFavorite}"
      >
        <div>{{dataItem.label}}</div>
      </div>
    </ng-template>
  </bfx-autoComplete>
</div>
